module.exports = __webpack_public_path__ + "img/glass.4309ef08.png";